import { useEffect, useState, RefObject } from 'react'
import {
  COURSE_VERTICAL_CARD_SLIDER_MARGIN,
  COURSE_VERTICAL_CARD_WIDTH,
} from 'components/ui/CourseCards/components/molecules/CourseVerticalCard/constants'
import { useWindowSize } from './react.hooks'

interface UseSlidesToShowProps {
  containerRef: RefObject<HTMLDivElement>
  slideWidth?: number
}

const useSlidesToShow = ({
  containerRef,
  slideWidth = COURSE_VERTICAL_CARD_WIDTH + COURSE_VERTICAL_CARD_SLIDER_MARGIN,
}: UseSlidesToShowProps) => {
  const [slidesToShow, setSlidesToShow] = useState(0)
  const { width } = useWindowSize()

  useEffect(() => {
    if (!containerRef.current) return

    const containerWidth = containerRef.current.offsetWidth
    setSlidesToShow(Math.floor(containerWidth / slideWidth))
  }, [containerRef, width, slideWidth])

  return slidesToShow
}

export default useSlidesToShow
